const specialOperators = ["-ve","SQ","SQRT"];

export default specialOperators;